import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'swisslife-prevoyance',
    templateUrl: './swisslife-prevoyance.component.html',
    styleUrls: ['./swisslife-prevoyance.component.scss'],
    standalone: false
})
export class SwisslifePrevoyanceComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;

  options: FormControlOption[] = [
    {
      value: 'SLPI',
      label: 'SwissLife Prévoyance Indépendants (SLPI)',
      suffix: { title: 'A' },
    },
    {
      value: 'SLP_TNS',
      label: 'SwissLife Prévoyance TNS Arti/Com (SLPTNS)',
      suffix: { title: 'B' },
    },
    {
      value: 'SPE',
      label: 'SwissLife Prévoyance Salariés (SLPS)',
      suffix: { title: 'C' },
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
